import PlaceBidModal from "./PlaceBidModal";

export default PlaceBidModal;
